<script>
  import { activeClass, exactClass, link } from "../../../../core";
  import FileCount from "./FileCount.svelte";

  interface ITopNavigationItem {
    isActive: boolean;
    title: string;
    url: string;
    showNewConstructionFileCount: boolean;
  }

  let navigation: Promise<ITopNavigationItem[]> = fetch(
    `/api/LindOgRisorNavigation/getDesktopTopNavigation`
  ).then((r) => r.json());
</script>

<div class="nav-wrapper">
  {#await navigation then navList}
    {#each navList as { url, title, showNewConstructionFileCount }}
      <div class="nav-item">
        <a
          href={url}
          use:link
          use:activeClass={"nav-item--active"}
          use:exactClass={"nav-item--exact"}>{title}</a
        >

        <!-- <Link
          href={url}
          activeExactClass="nav-item--exact"
          activeClass={"nav-item--active"}
        >
          {title}
        </Link> -->
        {#if showNewConstructionFileCount}
          <FileCount />
        {/if}
      </div>
    {/each}
  {/await}
</div>

<style lang="scss">
  .nav-wrapper {
    display: flex;
    flex-wrap: wrap;
    row-gap: 10px;
  }

  .nav-item {
    display: flex;
    flex-wrap: nowrap;
    font-size: 18px;
    line-height: 1.22;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 1.8px;
    white-space: nowrap;

    &:not(:last-child) {
      margin-right: 35px;
    }

    :global(a) {
      text-decoration: none;
      color: $key-color;
      padding-bottom: 2px;

      &:hover {
        color: $contrast-color;
      }
    }
  }

  :global(.nav-item--active) {
    cursor: default;
    box-shadow: 0 3px 0 0 $contrast-color;
  }
</style>
